import { IFormatObjectEditable } from "..";
import { IFormatAlert } from "../IFormatAlert";
import { IObjectValidator } from "../IObjectValidator";
import { TagObjectEditor } from "../objectEditors";
import { AbstractFormatObjectAlert, ObjectAlert } from "../alerts";

export class TagObjectValidator implements IObjectValidator {
  public validate(object: IFormatObjectEditable): IFormatAlert[] {
    const alerts: AbstractFormatObjectAlert[] = [];
    if (object instanceof TagObjectEditor) {
      if (object.lineBreakBehavior().isEditable() && object.fontSizeAutoAdjustBehavior().isEditable()) {
        const fontSizeAutoAdjust = object.fontSizeAutoAdjustBehavior().getValue();
        const lineBreak = object.lineBreakBehavior().getValue();
        if (!fontSizeAutoAdjust.isEnable && lineBreak.isEnable) {
          alerts.push(new ObjectAlert(object, "「禁則処理」を有効にする際は、「文字サイズ自動調節する」も有効にしてください"));
        }
      }
    }
    return alerts;
  }
}
